var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointBasedGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.375 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.813 13.619v6.733l.946 1.419a.516.516 0 00.858 0l.946-1.419v-6.733a7.255 7.255 0 01-2.75 0zM6.188 0a6.188 6.188 0 106.188 6.188A6.188 6.188 0 006.188 0zm0 3.266a2.925 2.925 0 00-2.922 2.922.516.516 0 01-1.031 0 3.958 3.958 0 013.953-3.954.516.516 0 010 1.031z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointBasedGrid);
export default __webpack_public_path__ + "static/media/point-based-grid.d4e4b1bd86e4f502038d9aa2249eeaf2.svg";
export { ForwardRef as ReactComponent };